import React from 'react';
import { observer } from "mobx-react";
import CartProblemLoadV1 from 'ReactApp/Components/CartProblemLoadV1/CartProblemLoadV1';
import CartOrderV1 from 'ReactApp/Components/CartOrderV1/CartOrderV1';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import CartOrderErrorV1 from 'ReactApp/Components/CartOrderErrorV1/CartOrderErrorV1';
import CartOrderCreatedV1 from 'ReactApp/Components/CartOrderCreatedV1/CartOrderCreatedV1';
import CartOrderCreateProcessV1 from '../CartOrderCreateProcessV1/CartOrderCreateProcessV1';

type CartPreOrderWrapV1Props = {
    showableCart: ShowableCart
}

const CartPreOrderWrapV1 = observer((props: CartPreOrderWrapV1Props) => {

    if (props.showableCart.isCartDataLoaded === false) {
        return (
            <CartProblemLoadV1 {...{
                showableCart: props.showableCart
            }} />
        );
    } else if (props.showableCart.isOrderCreated === true) {
        return (
            <CartOrderCreateProcessV1 {...{
                showableCart: props.showableCart
            }} />
        );
    } else {
        return (
            <>
                <CartOrderErrorV1 {...{
                    showableCart: props.showableCart
                }} />
                <CartOrderV1 {...{
                    showableCart: props.showableCart
                }} />
            </>
        );
    }

})

export default CartPreOrderWrapV1;